<template>
  <form class="p-2" @submit.prevent="handleAddItem">
    <ModalContainer :show="show" @close="onCancel">
      <template slot="header">
        <h4 class="mb-0 text-capitalize">
          {{ isEdit ? $t("edit_drop_off") : $t("add_drop_off") }}
        </h4>
      </template>

      <template slot="body">
        <div class="d-flex align-items-center col-gap-1">
          <div class="form-group w-100">
            <label for="fullname">{{ $t("delivery_date/time") }}</label>
            <input
              type="datetime-local"
              v-model="item.deliveryDate"
              class="form-control"
              required
              id="fullname"
              :min="minDeliveryDate"
            />
          </div>

          <div class="form-group w-100">
            <label for="fullname">{{ $t("item_name") }}</label>
            <input
              type="text"
              v-model="item.name"
              class="form-control"
              required
              id="fullname"
            />
          </div>
        </div>

        <div class="d-flex align-items-center col-gap-1">
          <div class="form-group w-100">
            <label for="fullname">{{ $t("weight") }}</label>
            <input
              type="text"
              v-model="item.weight"
              class="form-control"
              required
              id="fullname"
            />
          </div>

          <div class="form-group w-100">
            <label for="quantity">{{ $t("quantity") }}</label>
            <input
              type="text"
              v-model.number="item.quantity"
              class="form-control"
              required
              id="quantity"
              @keypress="IsNumber($event)"
              inputmode="numeric"
            />
          </div>
        </div>

        <div class="d-flex align-items-center col-gap-1">
          <div class="form-group w-100">
            <label for="logisticsType">{{ $t("logistics") }}</label>
            <select
              class="form-control text-capitalize"
              style="height: 50px"
              v-model="item.logisticsType"
              id="logisticsType"
              required
            >
              <option value="" disabled>
                {{ $t("select") }} {{ $t("contact") }}
              </option>
              <option
                v-for="logisticsType in logisticsTypes"
                :value="logisticsType"
                :key="logisticsType"
              >
                {{ logisticsType }}
              </option>
            </select>
          </div>

          <div class="form-group w-100">
            <label for="fullname">{{ $t("Price") }}</label>
            <input
              type="text"
              v-model.number="item.price"
              class="form-control"
              required
              id="fullname"
              @keypress="IsNumber($event)"
              inputmode="numeric"
            />
          </div>
        </div>

        <div class="form-group">
          <label for="fullname">{{ $t("description_optional") }}</label>
          <input
            type="text"
            name="name"
            v-model="item.description"
            class="form-control"
            id="fullname"
          />
        </div>
      </template>
      <template slot="footer">
        <div style="display: flex; justify-content: end">
          <button type="submit" class="btn btn-primary text-capitalize">
            {{ $t("add") }}
          </button>
        </div>
      </template>
    </ModalContainer>
  </form>
</template>

<script>
import ModalContainer from "../../../components/ModalContainer.vue";

export default {
  name: "AddItemModal",
  components: {
    ModalContainer,
  },

  props: {
    show: Boolean,
    onCancel: Function,
    itemData: Object,
  },
  data() {
    return {
      item: {},
      isEdit: false,
      logisticsTypes: ["internal", "external"],
    };
  },
  methods: {
    handleAddItem() {
      if (this.isEdit) {
        this.$emit("edit-item", this.item);
        return;
      }

      this.$emit("add-item", this.item);
    },
    IsNumber(event) {
      if (!/^[0-9]\d*(\.\d+)?$/.test(event.key)) return event.preventDefault();
    },
  },
  computed: {
    minDeliveryDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      const day = now.getDate().toString().padStart(2, "0");
      const hours = now.getHours().toString().padStart(2, "0");
      const minutes = now.getMinutes().toString().padStart(2, "0");

      return `${year}-${month}-${day}T${hours}:${minutes}`;
    },
  },
  watch: {
    itemData: {
      handler(val) {
        if (val.name) {
          this.isEdit = true;
          this.item = { ...val };
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
